export default function Header() {
  return (
    <div className="text-3xl font-extrabold text-white tracking-wider">
      What's up, today ?
    </div>
  );
}
